<div mat-dialog-title class="modal-header">
    <div class="row">
        <div class="col-xs-10">
            {{data.title}}
        </div>
        <div class="col-xs-2 text-right">
            <span class="glyphicon glyphicon-remove remove-button" aria-hidden="true" (click)="closeDialog('cancelled')"></span>
        </div>
    </div>
</div>
<div mat-dialog-content class="modal-body business-list-content fixed-height">
    <div class="row">
        <div class="col-md-12">
            <carm-table-filter
              inId="filterBusinesses"
              [filterOptions]="filterOptions"
              (searchButtonClicked)="loadBusinessList($event)"
              (clearButtonClicked)="loadBusinessList()">
            </carm-table-filter>
        </div>
    </div>
    <div class="row" *ngIf="(isCurrentNativeBusinessSelected$ | async) === false && displayCurrentNativeBusiness === true">
        <div class="col-md-12" *ngIf="(nativeBusiness$ | async) as nativeBusiness">
          <div  class="native-business-container">
            <div><i class="fa-home fas"></i> {{nativeBusiness.legalName}}({{nativeBusiness.uid}}) </div>
            <div><button class="basic-button-narrow carm-primary-button" (click)="setNativeAsCurrentBusiness(nativeBusiness)"> {{ 'button.select' | translate }} </button></div>
          </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12 select-business-list" [ngClass]="{'business-selector-fr': localeId === 'fr'}">
            <carm-ag-grid
            [serverDataSource]="businessList"
            [enablePagination]="true"
            [paginationSize]="10"
            [agGridConfig]="agGridConfig"
            [bottomPagePosition]="true"
            (actionButtonClick)="manageButtonActions($event)"
            inId="BusinessList">
        </carm-ag-grid>
        </div>
    </div>
</div>
